import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { getlang } from 'src/helper/getlang'

@inject('store')
@observer

export default class extends Component {
  state = {
    lang: {},
    language:'en',
  }
  constructor(props) {
    super(props)
    this.homePcStore = this.props.store.register('home/pcnew')
    this.initLang()
  }
  async initLang() {
    let language =await getlang()
    let lang = await this.homePcStore.getLang(language)
    this.setState({
      lang: lang
    })
  }
  render() {
    let { lang } = this.state
    return (
      <div className={`home-mb-App-about ${lang.mainLang == 'بالعربية' ? 'arL' : ''}`}>
        <div className="main-wrap">
          <div className="header">
            <div className="logo"></div>
            {/* <div className="recharge">
              {lang.recharge}
            </div> */}
          </div>

          {/* 关于、联系 */}
          <div className="ac-main">
            <div className="about-title">
              {lang.about}
            </div>
            <div className="about-txt">
              {lang.aboutCtx}
            </div>
            <div className="contact-title">
              {lang.contact}
            </div>
            <div className="contact-txt" dangerouslySetInnerHTML={{ __html: lang.contactCtx }} />
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/home/about/index.js